import algoliasearch from 'algoliasearch/lite'
import instantsearch from 'instantsearch.js'
import { searchBox, hits, pagination, panel } from 'instantsearch.js/es/widgets'
import customCurrentRefinements from './current-refinements'
import customRefinementList from './refinement-list'
import customSortby from './sortby'
import searchRouting from './search-routing'

if ($('#search-results').length && $('#search-index-name').val()) {
  const searchClient = algoliasearch('L39T1QHT93', 'c8189673c1e22052b2958f5d5ffe2d9a')
  const indexName = $('#search-index-name').val()

  const search = instantsearch({
    indexName: indexName,
    searchClient,
    routing: searchRouting(indexName),
  })

  const searchPanel = panel({
    templates: {
      footer (options) {
        let footer = '<div class="_algolia-summary-text">'
        if (options.results) {
          footer += `${options.results.nbHits} result${options.results.nbHits !== 1 ? 's' : ''} found`
          if (options.results.query) {
            footer += ` for <strong>${options.results.query}</strong>`
          }
        }
        return footer + '<span id="current-refinements"></span></div>'
      },
    },
  })(searchBox)

  const italiciseBracketedString = string => {
    if (typeof string !== 'string') {
      return ''
    }
    return string.replace(/\[([^\]]*)\]/g, '<span class="highlight">$1</span>')
  }

  search.addWidgets([
    searchPanel({
      container: '#search-box',
      placeholder: 'Search for keyword or phrase...',
      showReset: false,
      searchAsYouType: true,
      cssClasses: {
        form: '_algolia-search-box',
        input: '_algolia-search-box__text-input',
        submit: 'c-button'
      },
      templates: {
        submit: `
          Search
          <svg class="c-button__icon c-svg-icon">
            <use xlink:href="/_resources/themes/default/images/icons/icons.svg#icon-arrow-right"></use>
          </svg>
        `
      }
    }),

    customSortby({
      container: '#search-sortby',
      items: [
        {
          label: 'Most relevant',
          value: indexName
        },
        {
          label: 'Recently updated',
          value: indexName + '_sortby_latest'
        }
      ]
    }),

    pagination({
      container: '#search-pagination',
      showFirst: false,
      showLast: false,
      scrollTo: '#search-box',
      cssClasses: {
        root: 'c-pagination',
        noRefinementRoot: [
          'c-pagination',
          'c-pagination--empty',
        ],
        list: 'c-pagination__list',
        previousPageItem: [
          'c-pagination__control',
          'c-pagination__control--prev'
        ],
        nextPageItem: [
          'c-pagination__control',
          'c-pagination__control--next'
        ],
        pageItem: 'c-pagination__item',
        selectedItem: [
          'c-pagination__item',
          'c-pagination__item--selected'
        ],
        disabledItem: [
          'c-pagination__item',
          'c-pagination__item--disabled'
        ],
        link: 'c-pagination__link'
      },
      templates: {
        previous: 'Prev',
        next: 'Next'
      }
    }),

    customRefinementList({
      container: '#search-tags',
      optionsSelector: '#tag-options',
      title: 'Topics',
      attribute: 'objectTags',
      operator: 'and',
      limit: 4,
    }),

    customRefinementList({
      container: '#search-types',
      optionsSelector: '#type-options',
      title: 'Content Type',
      attribute: 'objectContentType',
      operator: 'or',
      limit: 4,
    }),

    customCurrentRefinements({
      container: '#current-refinements',
    }),

    hits({
      container: '#search-results',
      cssClasses: {
        list: 'c-results-list',
        item: 'c-results-list__item'
      },
      transformItems(items) {
        return items.map(item => ({
          ...item,
          tags: (item.objectTags || []).map(tag => {
            // Look up title/URL of tag from list output on page
            const tagMeta = $('#tag-options option[value="' + tag + '"]')
            return {
              url: tagMeta.data('url') || '/search/?tag=' + tag,
              title: tagMeta.data('title') || tag
            }
          }),
          contentType: (() => {
            const typeMeta = $('#type-options option[value="' + item.objectContentType + '"]')
            return typeMeta.length === 0 ? null : {
              url: typeMeta.data('url') || '/search/?type=' + item.objectContentType,
              title: typeMeta.data('title') || item.objectContentType
            }
          })(),
          objectTitle: italiciseBracketedString(item.objectTitle),
          objectPreviewContent: italiciseBracketedString(item.objectPreviewContent),
        }))
      },
      templates: {
        item: `
          <div class="c-result">
              <a class="c-result__image-link" href="{{ objectLink }}">
                  <img class="c-result__image" src="{{ objectPreviewImage }}" width="180" height="120" />
              </a>
              <div class="c-result__content">
                  <h4 class="c-result__title">
                      <a class="c-result__link" href="{{ objectLink }}">
                          {{& objectTitle }}
                      </a>
                  </h4>
                  <time class="c-result__date">{{ objectDateDisplay }}</time>
                  <div class="c-result__desc">
                      <a class="c-result__link" href="{{ objectLink }}">
                          {{& objectPreviewContent }}
                      </a>
                  </div>
                  <a class="c-result__location" href="{{ objectLink }}">{{ objectLink }}</a>
                  <ul class="c-tag-list">
                    {{# contentType }}
                      <li class="c-tag-list__item">
                        <a href="{{ url }}" class="c-tag c-tag--content-type c-tag--small">{{ title }}</a>
                      </li>
                    {{/contentType}}
                    {{# tags}}
                      <li class="c-tag-list__item">
                          <a class="c-tag c-tag--small c-tag--topic" href="{{ url }}">{{ title }}</a>
                      </li>
                    {{/tags}}
                  </ul>
              </div>
          </div>
        `,
        empty: 'No results found',
      }
    }),
  ])

  search.start()
}
